import React from "react";

/**
 * The three envelope fields every endpoint returns, for use at the top of a
 * response parameter table. The endpoint's own payload is documented beneath
 * these as `data...` rows.
 */
function EnvelopeRows() {
  return (
    <>
      <tr>
        <td>statusCode</td>
        <td>integer</td>
        <td>200 on success, otherwise the failure status</td>
      </tr>
      <tr>
        <td>message</td>
        <td>string</td>
        <td>"Success", or the reason for the failure</td>
      </tr>
      <tr>
        <td>errorCode</td>
        <td>string</td>
        <td>null on success; a stable DPI-xxxx code on failure</td>
      </tr>
    </>
  );
}

export default EnvelopeRows;
